import script from "./DuplicationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicationPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__